<style scoped>
  .layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: auto;
    min-height: 100vh;
  }
  .layout-header-bar{
    background: #fff;
    box-shadow: 0 1px 1px rgba(0,0,0,.1);
  }
</style>
<template>
  <div class="layout">
    <Sider :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}">
      <div style="height:64px;width: 100%;line-height: 64px;color:white;text-align: center;background-color: #5B6270">
        小程序后台管理【渠道版】
      </div>
      <Menu :active-name="active" theme="dark" width="auto" :open-names="opens">

        <Submenu name="0" >
          <template slot="title">
            首页管理
          </template>
          <MenuItem name="/home/Banners?p=0"  to="/home/Banners?p=0" >轮播图管理</MenuItem>
          <MenuItem name="/home/Keywords?p=0"  to="/home/Keywords?p=0" >搜索关键词</MenuItem>
        </Submenu>

        <MenuItem name="/apply/Apply"  to="/apply/Apply">订单管理</MenuItem>

        <MenuItem name="/home/Classify?p=-1" to="/home/Classify?p=-1"  >课程分类管理</MenuItem>
<!--        <Submenu name="1">-->
<!--          <template slot="title">-->
<!--            用户信息管理-->
<!--          </template>-->
<!--        </Submenu>-->

        <Submenu name="6" >
          <template slot="title">
            资料管理
          </template>

          <MenuItem name="/ziliao/ZiliaoFenlei?p=6"  to="/ziliao/ZiliaoFenlei?p=6" >分类管理</MenuItem>
          <MenuItem name="/ziliao/ZiliaoFiles?p=6"  to="/ziliao/ZiliaoFiles?p=6" >文件管理</MenuItem>
        </Submenu>

        <MenuItem name="/Zhutui"  to="/Zhutui" >首页主推课程</MenuItem>
        <MenuItem name="/City"  to="/City" >开课城市管理</MenuItem>
        <MenuItem name="/Task"  to="/Task" >定时任务</MenuItem>
        <MenuItem name="/Mp4Tool"  to="/Mp4Tool" >视频生成工具</MenuItem>

      </Menu>
    </Sider>
    <Layout :style="{marginLeft: '200px'}">
      <Header :style="{background: '#fff', boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)'}">

        <div style="float: right;">
          <Avatar style="background-color: #2299EE">{{$storage.getSession('uname').substring(0,1)}}</Avatar>
          &nbsp;&nbsp;
          <Dropdown @on-click="clickMenu">
            <span style="cursor:pointer;">
               {{$storage.getSession('uname')}}
                <Icon type="ios-arrow-down"></Icon>
            </span>
            <DropdownMenu slot="list">
              <DropdownItem name="loginout">退出登录</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Header>
      <Content :style="{marginTop:'8px'}">
        <div style="height: 100%">
          <router-view></router-view>
        </div>
      </Content>
    </Layout>

  </div>
</template>
<script>

  export default {
    data(){
      return{
        str:'',
        modal2:false,
        active:'/home/Banners',
        opens:[],
      }
    },
    methods:{
      clickMenu(name){
        if('loginout'===name){
          this.loginout();
        }else if('pass'===name){
          this.modal1 = true;
        }
      },
      loginout(){
        let that = this;
        this.$axios.get('/api/user/loginout').then(function(rs){
          that.$router.push({path:'/login'});
          that.$storage.removeStorage('uid');
          that.$storage.removeStorage('uname');
          that.$Message.success('退出成功');
        });
      },
      get() {
      }
    },
    created(){
      //需要进行权限加载
      let that = this;
      if(this.$router.history.current.path=='/'){
        // this.$router.push({path:'/home/Banners?p=0'});
      }
      this.active = this.$router.currentRoute.fullPath;
      this.opens = [this.$router.currentRoute.query.p];
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue